// Translation mappings for navigation items (English and Portuguese only)
const categoryTranslations = {
  en: {
    archive: "Archive",
    iphone: "iPhone",
    music: "Music",
    portraits: "Portraits",
    scenics: "Scenics",
  },
  pt: {
    archive: "Arquivo",
    iphone: "iPhone",
    music: "Música",
    portraits: "Retratos",
    scenics: "Paisagens",
  },
};

// Only locations that need a different label per language.
// Missing keys keep their formatted slug (do nothing).
const subcategoryTranslations = {
  en: {
    iguazu: "Iguazu Falls",
    japan: "Japan",
    "new-york": "New York",
  },
  pt: {
    iguazu: "Cataratas do Iguaçu",
    japan: "Japão",
    "new-york": "Nova York",
  },
};

/**
 * Format a subcategory slug for display (no translation).
 * e.g. "new-york" → "New York", "arizona&nevada" → "Arizona & Nevada"
 */
export const formatSubcategorySlug = (subcategory) =>
  subcategory
    .replace(/-/g, " ")
    .replace(/&/g, " & ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

/**
 * Translate a category name to the specified language
 * @param {string} category - Category name (e.g., 'archive', 'portraits')
 * @param {string} language - Language code ('en' or 'pt')
 * @returns {string} Translated category name
 */
export const translateCategory = (category, language = "en") => {
  const lang = language.toLowerCase();
  const categoryLower = category.toLowerCase();

  // If translation exists, return it
  if (categoryTranslations[lang] && categoryTranslations[lang][categoryLower]) {
    return categoryTranslations[lang][categoryLower];
  }

  // Fallback to English if translation doesn't exist
  if (categoryTranslations.en && categoryTranslations.en[categoryLower]) {
    return categoryTranslations.en[categoryLower];
  }

  // If no translation exists, capitalize the category name
  return category === "iphone"
    ? "iPhone"
    : category.charAt(0).toUpperCase() + category.slice(1);
};

/**
 * Translate a subcategory/location slug if a translation exists.
 * If not, return the formatted slug (do nothing — no invented translation).
 * @param {string} subcategory - URL slug (e.g., 'japan', 'new-york')
 * @param {string} language - Language code ('en' or 'pt')
 * @returns {string} Translated or formatted subcategory name
 */
export const translateSubcategory = (subcategory, language = "en") => {
  const lang = language.toLowerCase();
  const key = subcategory.toLowerCase();

  if (subcategoryTranslations[lang]?.[key]) {
    return subcategoryTranslations[lang][key];
  }

  return formatSubcategorySlug(subcategory);
};

// /**
//  * Get all translations for a language
//  * @param {string} language - Language code ('en' or 'pt')
//  * @returns {object} Object with all translations for the language
//  */
// export const getTranslations = (language = "en") => {
//   return categoryTranslations[language] || categoryTranslations.en;
// };

export default categoryTranslations;
